import { lazy } from 'react';

export const EmployeesPage = lazy(
  () => import('./ui/EmployeesPage/EmployeesPage'),
);

export const EmployeesDetailsPage = lazy(
  () => import('./ui/EmployeeDetailsPage/EmployeeDetailsPage'),
);
